<template>
  <vs-text v-if="job.assignmentGroupNumber" type="caption"
    >Assignment Group #{{ job.assignmentGroupNumber }} > Job #{{ job.number }}
  </vs-text>
  <vs-text v-else type="caption">Job #{{ job.number }} </vs-text>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Prop } from 'vue/types/options'

export default defineComponent({
  name: 'JobBreadcrumbs',

  props: {
    job: {
      type: Object as Prop<{
        number: number
        assignmentGroupNumber: number | undefined
      }>,
    },
  },
})
</script>

<style scoped></style>
